import { Controller } from '@hotwired/stimulus'
import type { Tooltip } from 'bootstrap'

export default class extends Controller<HTMLElement> {
    static targets = ['button', 'lockIcon', 'unlockIcon']
    declare readonly buttonTarget: HTMLElement
    declare readonly lockIconTarget: HTMLElement
    declare readonly unlockIconTarget: HTMLElement

    declare lockActive: boolean
    declare lockParent: string
    declare tooltip: Tooltip

    connect() {
        this.lockActive = this.element.dataset.lockActive === 'true'
        this.lockParent = this.element.dataset.lockParent || ''

        // Initialize forms on load
        this.toggleVisible()

        // Load tooltips
        this.tooltip = new bootstrap.Tooltip(this.buttonTarget, { container: 'body' })
    }

    toggle(event) {
        this.tooltip.hide() // Hide tooltip on click so it doesn't linger
        this.lockActive = !this.lockActive

        // Swap lock and unlock icons
        if (this.lockActive) {
            this.buttonTarget.classList.add('active')
            this.lockIconTarget.classList.remove('d-none')
            this.unlockIconTarget.classList.add('d-none')
        } else {
            this.buttonTarget.classList.remove('active')
            this.lockIconTarget.classList.add('d-none')
            this.unlockIconTarget.classList.remove('d-none')
        }

        // Toggle whether clone form or edit form is visible
        this.toggleVisible()

        // Notify conversions.js to reorder conversions
        if (this.lockParent === 'conversions') {
            $('#conversions-settings').trigger('conversionLockToggle')
        }

        event.preventDefault()
    }

    toggleVisible() {
        if (['menu_options', 'prompts'].includes(this.lockParent)) {
            // Skip for Vue forms where this is handled
            return
        }

        // Persist lock state in hidden text input
        const railsHiddenInput = document.querySelector(
            `#number_${this.lockParent}_use_cs`,
        ) as HTMLInputElement
        if (railsHiddenInput) railsHiddenInput.value = `${this.lockActive}`

        // Swap editable form with inherited (campaign) clone form
        const currentClone = $(`#${this.lockParent}-settings-clone`)
        const currentEditable = $(`#${this.lockParent}-settings`)
        if (this.lockActive) {
            currentClone.show()
            currentEditable.hide()

            // Disable add button and form inputs
            if (this.lockParent == 'conversions') {
                const conversionAddBtn = document.getElementById('add-field-conversion_groups')
                if (conversionAddBtn) conversionAddBtn.setAttribute('disabled', 'disabled')
                $(document).find('*[id*="conversion_groups_attributes"]').prop('disabled', true)
            }
        } else {
            currentClone.hide()
            currentEditable.show()

            // Enable add button and form inputs
            if (this.lockParent == 'conversions') {
                const conversionAddBtn = document.getElementById('add-field-conversion_groups')
                if (conversionAddBtn) conversionAddBtn.removeAttribute('disabled')
                $(document).find('*[id*="conversion_groups_attributes"]').removeAttr('disabled')
            }
        }

        $('.inherited-assets').each((index, ele) => {
            // @ts-ignore: global reference to assets.js
            assets.disable_remove(ele)
        })
    }
}
